module.exports = __webpack_public_path__ + "static/media/twitter.49c5dfc5.png";